import React, { useEffect, useReducer } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import { SIDEBAR_PORTAL_ID } from '../../../constants';

const Sidebar = styled.div`
    flex-basis: ${({ $isOpen }) => ($isOpen ? '25%' : '0')};
    flex-shrink: 0;
`;

export function Portal({ children, portalComponentRef, isPortalOpened }) {
    const portal = document.getElementById(SIDEBAR_PORTAL_ID) || portalComponentRef.current;
    const [, forceUpdate] = useReducer((x) => x + 1, 0);
    useEffect(() => {
        forceUpdate();
    }, [portalComponentRef.current]);

    if (children && isPortalOpened && portal) {
        return createPortal(children, portal);
    }

    return children;
}

const SidebarEmbedPortal = React.forwardRef(({ isOpen }, ref) => (
    <Sidebar ref={ref} $isOpen={isOpen} id={SIDEBAR_PORTAL_ID} />
));

SidebarEmbedPortal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
};

export default SidebarEmbedPortal;
